"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgButler = function SvgButler(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.339 5.318c.637-.208.955-.45.955-.725.367.467 1.297 1.087 3.98.725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04 9.7c-.92-.931-1.38-1.716-1.38-2.356 0-.639.352-.793 1.057-.463-.397-3.046.705-4.569 3.308-4.569 2.603 0 3.942.963 4.017 2.888-.165-.158-.425-.158-.78 0 .045.407.045.968 0 1.681 1.045-.246 1.39.097 1.036 1.027-.533 1.395-1.87 3.91-4.252 3.91-1.114-.066-2.116-.771-3.007-2.116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.97 11.543c1.104.403 2.242.815 2.963 1.358.72.542 1.081 1.264 1.081 2.165v5.447H6.021v-5.447c0-.9.36-1.623 1.082-2.165.72-.543 1.904-1.016 3.01-1.418.473 2.71.985 2.048 1.534 2.349.181.11.317.165.408.165.083 0 .206-.055.371-.165.55-.301 1.07.422 1.543-2.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m13.018 16.007.005-1.992 1.648-.556a1 1 0 0 1 1.32.95l-.005 1.293a1 1 0 0 1-1.362.929l-1.606-.624zm-2.04 0-.005-1.992-1.648-.556a1 1 0 0 0-1.32.95l.006 1.293a1 1 0 0 0 1.362.929l1.605-.624zM11 14h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 21 .015-4.98"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgButler);
var _default = exports["default"] = Memo;